import {
  getStoredAuthoringLanguage,
  normalizeAuthoringLanguageCode
} from "./authoringLibraryResources/authoringLibraryLanguages";
import { store } from "../store/store";

import de from "../assets/config/message-code-translations/de.json";
import en from "../assets/config/message-code-translations/en.json";
import es from "../assets/config/message-code-translations/es.json";
import fr from "../assets/config/message-code-translations/fr.json";
import hi from "../assets/config/message-code-translations/hi.json";
import hr from "../assets/config/message-code-translations/hr.json";
import ja from "../assets/config/message-code-translations/ja.json";
import pl from "../assets/config/message-code-translations/pl.json";
import ro from "../assets/config/message-code-translations/ro.json";
import sk from "../assets/config/message-code-translations/sk.json";
import sv from "../assets/config/message-code-translations/sv.json";
import uk from "../assets/config/message-code-translations/uk.json";

const messageCodesByLanguage: Record<string, Record<string, string>> = {
  de,
  en,
  es,
  fr,
  hi,
  hr,
  ja,
  pl,
  ro,
  sk,
  sv,
  uk
};

export interface MessageCodeResponse {
  message?: string;
  error?: string[];
}

export const getMessageFromCode = (code: string, language?: string): string => {
  const profileLanguage =
    store.getState().UserInfoSlice?.profile?.preferences?.language;
  const resolvedLanguage =
    language ||
    getStoredAuthoringLanguage() ||
    normalizeAuthoringLanguageCode(profileLanguage);

  const translations =
    messageCodesByLanguage[resolvedLanguage] || messageCodesByLanguage.en;
  return (
    translations[code as keyof typeof translations] ||
    messageCodesByLanguage.en[code as keyof typeof messageCodesByLanguage.en] ||
    code
  );
};

export const mapMessageCodes = (
  response: MessageCodeResponse,
  language?: string
): {
  successMessage?: string;
  warningMessages: string[];
  errorMessages: string[];
} => {
  const result = {
    successMessage: undefined as string | undefined,
    warningMessages: [] as string[],
    errorMessages: [] as string[]
  };

  // Handle success message
  if (response.message) {
    result.successMessage = getMessageFromCode(response.message, language);
  }

  // Handle error/warning messages
  if (response.error && Array.isArray(response.error)) {
    response.error.forEach((errorCode) => {
      const [code, severity] = errorCode.split("_");
      const message = getMessageFromCode(code, language);

      if (severity === "warning") {
        result.warningMessages.push(message);
      } else {
        result.errorMessages.push(message);
      }
    });
  }

  return result;
};
